import React from 'react'
import { Button, Card, Col, Flex, Image, Row, Typography } from 'antd'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { DownCircleOutlined } from '@ant-design/icons'
const { Text, Title } = Typography

const TrendingComponents = () => {

    const data = [
        {
            title:'Work from home jobs'
        },
        {
            title:'Immediate start jobs'
        },
        {
            title:'Manager jobs'
        },
        {
            title:'Finance jobs'
        },
        {
            title:'Warehouse jobs'
        },
        {
            title:'Accountant jobs'
        },
        {
            title:'Administrator jobs'
        },
        {
            title:'Part time jobs'
        },
        {
            title:'Receptionist jobs'
        },
        {
            title:'Customer service jobs'
        },
        {
            title:'Data entry jobs'
        },
        {
            title:'Graduate jobs'
        },
        {
            title:'Manager jobs'
        },
        {
            title:'Finance jobs'
        },
        {
            title:'Warehouse jobs'
        },
        {
            title:'Accountant jobs'
        },
        {
            title:'Administrator jobs'
        },
        {
            title:'Part time jobs'
        },
        {
            title:'Receptionist jobs'
        },
        {
            title:'Customer service jobs'
        },
        {
            title:'Data entry jobs'
        },
        {
            title:'Graduate jobs'
        },
    ]

  return (
    <div className='padding-t-m'>
        <div className='container'>
            <Row gutter={[24,24]} justify={'space-between'} align={'middle'}>
                <Col span={24}>
                    <Flex vertical gap={10} justify='center' className='text-center'>
                        <motion.div
                            initial={{ opacity: 0}}
                            whileInView={{
                                opacity: 1
                            }}
                            transition={{ duration: 2, ease: 'easeInOut' }}
                            viewport={{once: true}}
                        >
                            <Title level={1} className='m-0 brown-gadient'
                            >
                                Trending jobs
                            </Title>
                        </motion.div>
                        <motion.div
                            initial={{ y: 100, opacity: 0 }}
                            whileInView={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{ delay: .2, duration: 2, type:'spring', stiffness: 300 }}
                            viewport={{once: true}}
                        >
                            <Text className='text-gray fs-16'
                            >
                                Best trending jobs show bellow
                            </Text>
                        </motion.div>
                    </Flex>
                </Col>
                <Col span={24}>
                    <Flex wrap justify='center' gap={15}>
                        {
                            data?.map((jobs,index)=>
                                <Button key={index}>
                                    {
                                        jobs?.title
                                    }
                                </Button>
                            )
                        }
                    </Flex>
                    <Flex justify='center' className='py-3'>
                        <Title level={5} className='m-0 fs-500'>
                            <Link to={''}>
                                See more sectors
                                <DownCircleOutlined className='px-2' />
                            </Link>
                        </Title>
                    </Flex>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {TrendingComponents}